import { Component, ErrorInfo, PropsWithChildren } from 'react'

import { ErrorMessage } from './ErrorMessage'

type ErrorBoundaryState = {
  error?: Error
  errorInfo?: ErrorInfo
}

export class ErrorBoundary extends Component<PropsWithChildren> {
  state: ErrorBoundaryState = {}

  componentDidCatch = (error: Error, errorInfo: ErrorInfo) => {
    this.setState({ error, errorInfo })
  }

  render = () => {
    const { error, errorInfo } = this.state

    return error ? (
      <ErrorMessage message={error.message}>{errorInfo?.componentStack}</ErrorMessage>
    ) : (
      <>{this.props.children}</>
    )
  }
}
